import styled from 'styled-components';
import Box from './Box';

const FieldSet = styled(Box)`
  border: none;
`;

FieldSet.displayName = 'FieldSet';

FieldSet.defaultProps = {
  as: 'fieldset',
  mb: 20,
  p: 0,
  mx: 0,
  mt: 0
};

export default FieldSet;
